// Components
import { Box, Stack, Text } from "@mantine/core";
import { IconBellOff } from "@tabler/icons-react";

// Styles
import styles from "./ClinicalNotificationEmptyState.module.css";

/**
 * Explicit empty state for the notification center.
 * @agentic connections
 */
export const ClinicalNotificationEmptyState = ({
  message = "No notifications",
}: {
  message?: string;
}) => {
  return (
    <Stack align="center" gap="md" py="xl" role="status">
      <Box className={styles.icon}>
        <IconBellOff size={26} aria-hidden />
      </Box>
      <Text size="sm" className={styles.message}>
        {message}
      </Text>
    </Stack>
  );
};
